<div class="z-[999] fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center">
  <div class="bg-white rounded-2xl w-1/2 shadow-lg">
    
    <!-- Header -->
    <div class="flex justify-between items-center border-b border-gray-200 px-6 py-4">
      <h2 class="text-xl font-semibold text-dimot-1">Aggiungi attività e Tattiche dei Piani di Accesso Regionali</h2>
      <span 
        role="button"
        (click)="oncloseModal()"
        class="text-dimot-1 text-[1.2em] font-bold cursor-pointer hover:text-gray-400 transition">
       X
      </span>
    </div>

    <!-- Search Bar -->
    <div class="flex items-center px-6 py-3 gap-3 mt-2">
      <input id="activitySearch"
             type="text"
             class="w-1/3 text-sm rounded-md px-3 py-2 border border-gray-300 focus:border-gray-500 focus:ring-1 focus:ring-gray-500 outline-none transition"
             [(ngModel)]="searchTerm"
             placeholder="Cerca attività..."
             />
    </div>

    <!-- Table -->
    <div class="pl-6 h-[17rem] overflow-auto [&::-webkit-scrollbar]:w-1
  [&::-webkit-scrollbar-track]:rounded-full
  [&::-webkit-scrollbar-track]:bg-gray-100
  [&::-webkit-scrollbar-thumb]:rounded-full
  [&::-webkit-scrollbar-thumb]:bg-dimot-1
  dark:[&::-webkit-scrollbar-track]:bg-neutral-700
  dark:[&::-webkit-scrollbar-thumb]:bg-dimot-1">
      <table class="w-full text-sm">
        <tbody>
          <tr *ngFor="let row of filteredRows(); let i = index"
              [class.bg-gray-100]="selectedRows.includes(row)"
              class=" border-gray-200 hover:bg-gray-50 transition">
            <td class="p-3">
              <input type="checkbox" 
  class="w-4 h-4 border-gray-300 rounded-sm text-dimot-1 focus:ring-0 focus:outline-none"
                     [checked]="selectedRows.includes(row)" 
                     (click)="selectRow(row)">
            </td>
            <td class="p-3 text-dimot-1">{{ row.name }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Save Button -->
    <div class="flex justify-center py-4">
      <button 
      (click)="onSaveClick()"
      class="border-1 border-dimot-1 bg-dimot-1 text-white hover:bg-white hover:text-dimot-1 w-28 h-10 rounded-md flex flex-row justify-center gap-2 items-center cursor-pointer group"
      >
        <span class="text-[0.75em]">Aggiungi</span>

      </button>
    </div>
  </div>
</div>
